// <head> metadata for BlogPage (https://www.dbos.dev/blog).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Blog | DBOS',
    },
    {
      name: 'description',
      content:
        'Helpful articles about cloud-native architecture, transactional serverless computing, TypeScript, Java, Go, and Python backend development, and DBOS product updates.',
    },
    {
      property: 'og:title',
      content: 'Blog | DBOS',
    },
    {
      property: 'og:description',
      content:
        'Helpful articles about cloud-native architecture, transactional serverless computing, TypeScript, Java, Go, and Python backend development, and DBOS product updates.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Blog | DBOS',
    },
    {
      name: 'twitter:description',
      content:
        'Helpful articles about cloud-native architecture, transactional serverless computing, TypeScript, Java, Go, and Python backend development, and DBOS product updates.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/blog',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
